import { lazy } from 'react';
import { trackChunkLoadFailed } from './posthogEvents';

// Wrapper for lazy imports that handles chunk loading failures after deploys.
// moduleId is an explicit human-readable identifier used for analytics — parsing
// error.message is unreliable because the format varies across browsers.
export function lazyWithRetry(importFn, moduleId) {
  return lazy(() =>
    importFn().catch((error) => {
      const msg = error?.message || '';
      const isChunkError =
        msg.includes('Failed to fetch dynamically imported module') ||
        msg.includes('Loading chunk') ||
        msg.includes('Cannot find module');

      if (isChunkError) {
        console.warn('[LazyLoad] Chunk loading failed, refreshing page:', msg);
        trackChunkLoadFailed({
          module: moduleId,
          message: msg,
        });
        // Counter survives the reload; next boot's beacon payload reports
        // how many ChunkLoadError reloads preceded this pageload. A non-zero
        // value fingers rsync --delete as the cause of the slow post-deploy UX.
        try {
          const prev = +(sessionStorage.getItem('chunk_reload_count') || 0);
          sessionStorage.setItem('chunk_reload_count', String(prev + 1));
        } catch { /* storage unavailable */ }
        // Delay reload so PostHog can flush the event before the page unloads.
        // Same pattern as PaywallModal CTA click — capture() is async and the
        // synchronous reload would otherwise interrupt the in-flight request.
        setTimeout(() => window.location.reload(), 150);
        return new Promise(() => {});
      }

      throw error;
    })
  );
}
